import { render, staticRenderFns } from "./OrderDetailPage.vue?vue&type=template&id=ce49b46e&"
import script from "./OrderDetailPage.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports